export default __webpack_public_path__ + "static/favicon-c0c3e752b9f0379da6ec92e4f39331a7.ico";